import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de29104471c1e1/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/sections/DeviceShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/sections/EnhancedTestimonials.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de29104471c1e1/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/app/[locale]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
